import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import CustomSelect from "../../CommonElements/CustomSelect";
import { useController, useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import { CommonModal, Spinner } from "../../AbstractElements";
import { showAlert } from "../../Services/Shared.service";
import {
  assignVendorToBooking,
  getAssignVendorList,
  getAssignVendorListBasedOnVendorType,
} from "../../Services/Driver.service";

const VendorTypeList = [
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "Inactive",
    label: "Inactive",
  },
];

const AssignDriver = (props) => {

  console.log(">>> props value is ", props)

  const { control, register, setValue } = useForm();
  const [searchedData, setSearchedData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [bookingId, setBookingId] = useState(props.bookingId);
  const vendorTypeField = useController({
    name: "vendorType",
    control,
    defaultValue:"Active"
  }).field;

  const onVendorSelected = (element) => {
    console.log(element, 'element');
    setSelectedVendor(element);
  };

  const onInactiveVendorSelected = (element) => {
    console.log(element, 'element');
  };

  const handleVendorTypeSelect = (option) => {
    vendorTypeField.onChange(option.value);
  };

  const [selectedVendor, setSelectedVendor] = useState({});

  const onChangeInput = (event) => {
    console.log(event.target.value, "valuevalue");
    setSearchedData(event.target.value);
  };

  const [isSubmitting,setIsSubmitting] = useState(false)
  const [vendorData, setVendorData] = useState([]);
  
  useEffect(() => {
    console.log(
      props.Large,
      "props.Large"
    );
    fetchAssignVendorList();
  }, [vendorTypeField.value, bookingId, props.Large]);

  const fetchAssignVendorList = () => {
    console.log(">>>>>>> Search Data value is :::: ", searchedData);
    console.log(">>>>>>> VENDOR TYPE FIELD Data value is :::: ", vendorTypeField);
    setLoader(true);
    setSelectedVendor({});
    setSearchedData(null);
    setValue("searchTable", null);
    if(vendorTypeField.value === undefined || vendorTypeField.value === '')
    {
      getAssignVendorList()
      .then((result) => {
        setLoader(false);
        setVendorData(result.data);
      })
      .catch((err) => {
        setLoader(false);
        showAlert("error", err.response.data?.message ? err.response.data.message : "Something went Wrong");
        setVendorData([]);
      });
    }
    else{

      let obj = {
        serviceCityId : props.vendorBookingObj.serviceCityId ? props.vendorBookingObj.serviceCityId : 0,
        status : null,
      }

      if(vendorTypeField.value === "Active")
      {
          obj.status = 0
      }
      else if(vendorTypeField.value === "Inactive"){
          obj.status = 1
      }

      console.log("obj Value is >>>>>> ", obj);

      getAssignVendorListBasedOnVendorType(obj)
        .then((result) => {
          console.log(">>> Assign Vendor Type based fetch value is ::: ", result.data)
          setLoader(false);
          // setVendorData(result.data.list);
          const dataValue = result.data.list.filter((element) => element.id !== props.vendorBookingObj.aggregatorId).map((element) => {
            return {
              id: element.id,
              companyName: element.companyName ? element.companyName : "-",
              city: element.city ? element.city : "-",
              state: element.state ? element.state : "-",
              pincode: element.pincode ? element.pincode : "-",
            };
          })
          setVendorData(dataValue)
        })
        .catch((err) => {
          setLoader(false);
          showAlert("error", err?.response?.data?.message ? err?.response?.data?.message : "Something went Wrong");
          setVendorData([]);
        });
    }
  };

  const driverColumns = 
    vendorTypeField.value === "Active" ?
    [
      {
      name: "VENDOR ID",
      selector: (row) => row["id"],
      sortable: true,
      center: true,
      },
      {
        name: "VENDOR NAME",
        selector: (row) => row["companyName"],
        sortable: true,
        center: true,
      },
      {
        name: "CITY",
        selector: (row) => row["city"],
        sortable: true,
        center: true,
      },
      {
        name: "STATE",
        selector: (row) => row["state"],
        sortable: true,
        center: true,
      },
      {
        name: "PINCODE",
        selector: (row) => row["pincode"],
        sortable: true,
        center: true,
      },
      {
        name: "",
        selector: (row) => row["action"],
        sortable: true,
        center: true,
        width: "50px",
      },
      
    ] : [
      {
        name: "VENDOR ID",
        selector: (row) => row["id"],
        sortable: true,
        center: true,
      },
      {
        name: "VENDOR NAME",
        selector: (row) => row["companyName"],
        sortable: true,
        center: true,
      },
      {
        name: "CITY",
        selector: (row) => row["city"],
        sortable: true,
        center: true,
      },
      {
        name: "STATE",
        selector: (row) => row["state"],
        sortable: true,
        center: true,
      },
      {
        name: "PINCODE",
        selector: (row) => row["pincode"],
        sortable: true,
        center: true,
      },
    ];

  const assignVendor = () => {
    // vendorTypeField.onChange('');
    console.log(vendorTypeField.value, "Vendor on change value is ");
    
    props.setShowApiLoader(true);
    setIsSubmitting(true)
    console.log(selectedVendor, "selectedVendorData");
    let obj = {
      bookingId: props.bookingId,
      aggregatorId : selectedVendor ? selectedVendor.id : null,
    };
    console.log(obj, "obj");
    assignVendorToBooking(obj)
      .then((assignDriverRes) => {
        props.setShowApiLoader(false);
        setIsSubmitting(false)
        props?.onSubmitData?.fetchBookingData().then((result) => {
          props.LargeModaltoggle();
          vendorTypeField.onChange("Active")
        });
      })
      .catch((err) => {
        console.log(">>>>> Error is ", err.response);
        
        setIsSubmitting(false)
        props.setShowApiLoader(false);
        showAlert("error", err.response?.data ? err.response.data : "Something went wrong");
      });
  };

  const processData = vendorData
    .map((element, i) => {
      return {
        id: element.id,
        companyName: element.companyName ? element.companyName : "-",
        city: element.city ? element.city : "-",
        state: element.state ? element.state : "-",
        pincode: element.pincode ? element.pincode : "-",
        action: (
          <Fragment>
            <div key={i} onClick={() => onVendorSelected(element)}>
              {selectedVendor?.id && selectedVendor.id == element.id ? (
                <i className="fa fa-check"></i>
              ) : (
                <i className="fa fa-user-plus"></i>
              )}
            </div>
          </Fragment>
        ),
      };
    })
    .filter((element) => {
      if (searchedData) {
        console.log("present");
        console.log(
          element.companyName.toLowerCase().includes(searchedData.toLowerCase())
        );
        console.log(
          element.companyName.toLowerCase(),
          searchedData.toLowerCase()
        );
        if (
          element.companyName.toLowerCase().includes(searchedData.toLowerCase())
        ) {
          return element;
        }
      } else {
        return element;
      }
    });

  return (
    <CommonModal
      isOpen={props.Large}
      title={props.title}
      toggler={() => {
        vendorTypeField.onChange("Active")
        props.LargeModaltoggle()
      }}
      size="xl"
    >
      <Row className="book-a-cab">
        <Row>
          <Row className="justify-content-between">
            <Col className="col-lg-4">
              <CustomSelect
                className="driver-type-select"
                classNamePrefix="driver-type-select-options"
                isClearable={false}
                isSearchable={false}
                defaultValue={VendorTypeList.find((element) => {                
                  return element.value === vendorTypeField?.value;
                })}
                onChange={handleVendorTypeSelect}
                placeholder="Select Vendor Type"
                options={VendorTypeList}
              />
            </Col>
            <Col className="col-lg-4">
              <input
                className="form-control"
                type="text"
                {...register("searchTable", {
                  onChange: onChangeInput,
                })}
                placeholder="Search by Vendor Name"
                id="name"
                required
              />
            </Col>
          </Row>

          <Col className="col-12 mt-2 table-responsive assign-vendor-list">
            <DataTable
              columns={driverColumns}
              data={processData}
              center={true}
              onRowClicked={ vendorTypeField.value === "Active" ? onVendorSelected : onInactiveVendorSelected}
              fixedHeader
              fixedHeaderScrollHeight="51vh"
              pagination
              progressPending={loader}
              progressComponent={<div className="loader-box" style={{ height: "51vh" }}>
                <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
              </div>}
            />
          </Col>
        </Row>
        <Row className="submit-booking">
          <button
            disabled={ isSubmitting ? true : selectedVendor?.id ? false : true}
            className="btn btn-primary"
            onClick={assignVendor}
          >
            Done
          </button>
        </Row>
      </Row>
    </CommonModal>
  );
};

export default AssignDriver;

